export default {
  storeTo: 'Armazém para',
  weightHaveUnit: 'Peso (g)',
  productType: 'Tipo de produto',
  long: 'Comprimento (cm)',
  width: 'Largura (cm)',
  height: 'Altura (cm)',
  seeDetail: 'Ver detalhes',
  queryTips: 'Por favor, insira os parâmetros correspondentes para consultar o frete!',
  carrier: 'Transportadora',
  carrierCode: 'Código da transportadora',
  product: 'Produto',
  productCode: 'Código do produto',
  totalfee: 'Custo total',
  billingWeight: 'Peso de cobrança',
  feeEstimation: 'Estimativa de custo',
  postFeeEstimation: 'Estimativa de frete',
  postFee: 'Custo de transporte',
  postTime: 'Tempo de transporte',
  packUp: 'Recolher',
  startWeight: 'Peso inicial',
  endWeight: 'Peso final',
  calcExpression: 'Expressão de cálculo',
  baseFreight: 'Frete base',
  registrationFee: 'Taxa de registro',
  noSend: 'Não pode enviar',
  canSend: 'Pode enviar',
  priceFrom: 'Composição do preço',
  itemLimit: 'Restrição do produto',
  disReason: 'Motivo de desativação',
  BasicFreight: 'Frete básico',
  OperationFreight: 'Taxa de declaração',
  RegistrationFreight: 'Taxa de registro',
  IossFee: 'Taxa IOSS',
  TariffFreight: 'Tarifa',
  VATFregith: 'IVA',
  AserviceFee: 'Taxa de serviço adicional',
  ExtraSizeFreight: 'Taxa adicional por tamanho excessivo',
  AdditionalDeliveryFeeForFemoteAreas: 'Taxa adicional de entrega para áreas remotas',
  FuelSurcharge: 'Taxa de combustível',
  zoneCode: 'Zona ',
  amount: 'Preço ',
  rate: 'Taxa ',
  conditionExpression: 'Expressão de cálculo ',
  feeFactor: 'Fator de custo',
  continuedPrice: 'Preço de peso adicional',
  continuedWeight: 'Peso adicional(g)',
  firstPrice: 'Preço do primeiro peso',
  firstWeight: 'Peso do primeiro peso(g)',
  weightRangeStart: 'Peso inicial(g)',
  weightRangeEnd: 'Peso final(g)',
  holder: {
    toCountry: 'Selecionar destino',
    inputWeight: 'Por favor, insira o peso',
    selectCountry: 'Por favor, selecione o país',
    selectCarrier: 'Por favor, selecione transportadora/rota da transportadora/país da rota',
    selectCategory: 'Selecionar restrição de envio',
  },
  typeDelivery: 'Tipo de entrega',
  workDay: 'Dia útil',
  shippingTime: 'Tempo estimado de envio',
  deliveryTips: 'Dicas de entrega',
  estimatedShippingFee: 'Frete estimado',
  lineServiceTips:
    'Dica: Todos os serviços de logística de rotas não próprias do acbuy são fornecidos por provedores de logística terceirizados. Os provedores de logística terceirizados ajustarão os preços de frete de acordo com as condições de mercado. Se houver mudanças de preço, o acbuy notificará você com antecedência. Se você encontrar algum problema com os serviços de logística, o acbuy pode se comunicar com os provedores de logística terceirizados em seu nome.',
  logisticsStatement: '<Declaração de Serviço de Logística>',
  customizedDelivery: 'Serviço de entrega personalizado',
  customizedDeliveryText:
    'Envio de cargas grandes, transporte marítimo e ferroviário, você pode escolher serviço de envio personalizado',
  customizeNow: 'Personalizar agora',
  declareAmountRange: 'Faixa de valor declarado',
  viewUnavailableLines: 'Ver rotas desativadas (Desativadas:',
  'i18n-0000001': 'Taxa de entrega',
  'i18n-0000002':
    'Todos os pacotes enviados durante o período {timeStart} - {timeEnd}, a proporção de pacotes entregues até hoje',
  'i18n-0000003': 'Dias',
  couponDiscount: 'Desconto de cupom',
  expectedDiscount: 'Desconto estimado',
}
